import { Pipe, PipeTransform } from '@angular/core';
import {
  CompositeFilterDescriptor,
  FilterDescriptor,
  isCompositeFilterDescriptor,
} from '@progress/kendo-data-query';

const flatten = (filter: CompositeFilterDescriptor): FilterDescriptor[] => {
  const filters = (filter || {}).filters;
  if (!filters) {
    return [];
  }

  return filters.reduce(
    (result, current) =>
      result.concat(
        isCompositeFilterDescriptor(current) ? flatten(current) : [current]
      ),
    []
  );
};

/**
 * A pure pipe used to extract the filter values from the provided filter descriptors.
 */
@Pipe({
  name: 'filterValues',
})
export class FilterValuesPipe implements PipeTransform {
  public transform(filter: CompositeFilterDescriptor): any[] {
    let flattenedItem = flatten(filter)
      .map(descriptor => descriptor.value)
      .filter(value => value !== undefined);
    flattenedItem = flattenedItem.flat();
    flattenedItem = Array.from(new Set(flattenedItem));
    return flattenedItem;
  }
}
